import { Singleton } from '@/decorators';
import {
  GetAuthorizationRequestDTO,
  GetAuthorizationResponseDTO,
  SubmitAuthorizationRequestDTO,
  SubmitAuthorizationResponseDTO,
} from './DTOs';
import { AuthApi } from '../auth/authApi';
import type { Result } from '@/types/result.interface';
import type { AppError } from '@/types/errors.interface';
import { wrapHttpCall } from '../utils/apiResultMapper';

/**
 * Authorization API (Framework Agnostic)
 * 
 * Handles authorization data retrieval and submission.
 */
@Singleton
export class AuthorizationApi extends AuthApi {
  constructor() {
    super();
  }

  async getAuthorizationData(body: GetAuthorizationRequestDTO): Promise<Result<GetAuthorizationResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.get<GetAuthorizationResponseDTO>(
      `ApplicationForm/${body.applicationId}/authorization`,
    ));
  }

  async submitAuthorization(body: SubmitAuthorizationRequestDTO): Promise<Result<SubmitAuthorizationResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.post<SubmitAuthorizationResponseDTO>(
      `ApplicationForm/${body.applicationId}/authorization`,
      body.clientAuthorizations,
    ));
  }
}
